<template>
	<svg class="icon" width="24" height="26" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.01 22.01">
		<circle class="uuid-0d6a3a41-ddbd-40a3-ae08-4537f3b92375" cx="11.005" cy="11.005" r="11.005"
			:fill="circleColor" />
		<path class="uuid-dbbcff4c-4ba2-4376-b02d-48051d1cc97e"
			d="m4.006,11.005c0,3.59,3.134,6.5,7,6.5s7-2.91,7-6.5-3.134-6.5-7-6.5c-1.354,0-2.618,.357-3.689,.975"
			:stroke="pathColor" fill="none" stroke-linecap="round" stroke-width="1.5" />
		<path class="uuid-dbbcff4c-4ba2-4376-b02d-48051d1cc97e" d="m6.311,4.579l-.447,1.925,2.281,.304"
			:stroke="pathColor" fill="none" stroke-linecap="round" stroke-width="1.5" />
	</svg>
</template>

<script>
export default {
	props: {
		circleColor: String,
		pathColor: String,
		circleHoverColor: String,
		pathHoverColor: String,
	},
};
</script>

<style lang="scss" scoped>
.icon {
	max-width: 2.2rem;
	width: 100%;
	aspect-ratio: 1/1;
	transition: transform 0.3s;
}

.uuid-0d6a3a41-ddbd-40a3-ae08-4537f3b92375,
.uuid-dbbcff4c-4ba2-4376-b02d-48051d1cc97e {
	transition: transform 0.3s;
}

.icon:hover .uuid-0d6a3a41-ddbd-40a3-ae08-4537f3b92375 {
	fill: v-bind('circleHoverColor');
	transition: transform 0.3s;
}

.icon:hover .uuid-dbbcff4c-4ba2-4376-b02d-48051d1cc97e {
	stroke: v-bind('pathHoverColor');
	transition: transform 0.3s;
}
</style>
